import React from "react";
import { useTranslation } from "react-i18next";

import CardSoftware from "../../components/CardSoftware/CardSoftware";

import "./WhatWeDo.css";

const WhatWeDo = () => {
	const { t } = useTranslation();
	const techStack = t("team.full.whatWeDo.techStack", { returnObjects: true });

	return (
		<div className="what-we-do-bg">
			<h1 className="what-we-do-title">{t("team.full.whatWeDo.title")}</h1>

			<div className="what-we-do-container">
				{techStack.map((item, index) => (
					<CardSoftware
						key={index}
						data={{ id: index, name: item["name"], icon: item["icon"] }}
					/>
				))}
			</div>
		</div>
	);
};

export default WhatWeDo;
